import CustomButton from "../../../common/CustomButton";
import Lottie from "lottie-react";
import WomanWorkout from "../../user-onboarding/animations/WomanWorkout.json";


function SlideSuccessPage({ moveNext, backLogin }) {
    return (
        <div id="uo-welcome-page" className="uo-wp-resurvey-page uo-wp-rp-success uo-component div-35-65">
            <div id="uo-pi-pm-animation-banner">
                <div id="uo-pi-pm-ab-container">
                    <Lottie className="workout-animation" animationData={WomanWorkout} loop={true} />
                </div>
            </div>
            <div id="uo-wp-text" className="bottom-text-area">
                <h4>Your Schedule is Ready!</h4>
                <h6>Explore your calendar and get started with your new routine!</h6>
                <CustomButton className="uo-button active" onClick={moveNext}>Get Started</CustomButton>
                <div id="uo-wp-t-curve-shapes">
                    <img src="/assets/images/onboarding/onboarding-banner-curve-shapes.png" />
                </div>

            </div>
        </div>
    );
}

export default SlideSuccessPage;